var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useMemo, useCallback } from 'react';
import PolicyStepsHeader from '../../../../common/PolicyStepsHeader';
import useCustomerStore from '../../../../../stores/customerStore';
import Checkbox2 from '../../../../common/Checkbox2';
import useWidgetStore from '../../../../../stores/widgetStore';
import useLatestQuotesWithPolicies from '../../../../../hooks/useLatestQuotesWithPolicies';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import TableHeaderCell from './TableHeaderCell';
import FilterPopup from './FilterPopup';
var HorseGroupSelection = function (_a) {
    var onClick = _a.onClick;
    var _b = useCustomerStore().applicationFormData, applicationFormData = _b === void 0 ? {} : _b;
    var setModalOpen = useWidgetStore().setModalOpen;
    var latestQuotesWithPolicies = useLatestQuotesWithPolicies();
    var _c = useState([]), selectedHorseIds = _c[0], setSelectedHorseIds = _c[1];
    var _d = useState(''), searchQuery = _d[0], setSearchQuery = _d[1];
    var _e = useState('dateAdded'), sortField = _e[0], setSortField = _e[1];
    var _f = useState(true), sortOrderAsc = _f[0], setSortOrderAsc = _f[1];
    var isFiveHorsesSelected = selectedHorseIds.length >= 5;
    var rawHorses = useMemo(function () {
        return Object.entries(applicationFormData).map(function (_a) {
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var id = _a[0], data = _a[1];
            return ({
                id: id,
                passportName: ((_c = (_b = data.applicationDetails) === null || _b === void 0 ? void 0 : _b.HorseDetails) === null || _c === void 0 ? void 0 : _c.HorsePassportName) || 'N/A',
                gender: ((_e = (_d = data.applicationDetails) === null || _d === void 0 ? void 0 : _d.HorseDetails) === null || _e === void 0 ? void 0 : _e.HorseSex) || 'N/A',
                DOB: ((_g = (_f = data.applicationDetails) === null || _f === void 0 ? void 0 : _f.HorseDetails) === null || _g === void 0 ? void 0 : _g.HorseDOB) || 'N/A',
                dateAdded: ((_j = (_h = data.applicationDetails) === null || _h === void 0 ? void 0 : _h.HorseDetails) === null || _j === void 0 ? void 0 : _j.CreationDate) || 'N/A',
                yardName: ((_l = (_k = data.applicationDetails) === null || _k === void 0 ? void 0 : _k.InsuredDetails) === null || _l === void 0 ? void 0 : _l.CompanyName) || 'N/A',
                insuranceStatus: null
            });
        });
    }, [applicationFormData]);
    var extractUniqueValues = useCallback(function (columnName) {
        var uniqueValues = Array.from(new Set(rawHorses.map(function (horse) { return horse[columnName]; })));
        return uniqueValues;
    }, [rawHorses]);
    var _g = useState(extractUniqueValues('gender')), allowedGenders = _g[0], setAllowedGenders = _g[1];
    var _h = useState(false), showGenderPopup = _h[0], setShowGenderPopup = _h[1];
    var _j = useState(extractUniqueValues('yardName')), allowedYardNames = _j[0], setAllowedYardNames = _j[1];
    var _k = useState(false), showYardNamesPopup = _k[0], setShowYardNamesPopup = _k[1];
    var horses = useMemo(function () {
        var activeQuotes = latestQuotesWithPolicies.filter(function (quote) { var _a; return ((_a = quote.policy) === null || _a === void 0 ? void 0 : _a.insuranceStatus) == 'active'; });
        return rawHorses.map(function (horse) {
            var matchedQuotes = activeQuotes.filter(function (quote) { var _a; return (_a = quote.externalId) === null || _a === void 0 ? void 0 : _a.includes(horse.id); });
            var insurancePolicies = matchedQuotes
                .map(function (quote) { var _a, _b; return String(((_b = (_a = quote === null || quote === void 0 ? void 0 : quote.policy) === null || _a === void 0 ? void 0 : _a.partnerData) === null || _b === void 0 ? void 0 : _b.policyId) || ''); })
                .filter(function (id) { return id; });
            var limitedPolicies = insurancePolicies.slice(0, 2);
            return __assign(__assign({}, horse), { insuranceStatus: limitedPolicies.length > 0 ? limitedPolicies : null });
        });
    }, [rawHorses, latestQuotesWithPolicies]);
    // const availableHorses = useMemo(() => {
    //   const activeQuotes = latestQuotesWithPolicies.filter(
    //     (quote) => quote.policy?.insuranceStatus == 'active',
    //   );
    //   return horses.filter((horse) => {
    //     const isHorseCovered = activeQuotes.some((quote) =>
    //       quote.externalId?.includes(horse.HorseId),
    //     );
    //     return !isHorseCovered;
    //   });
    // }, [horses, latestQuotesWithPolicies]);
    var toggleSelection = useCallback(function (horseId) {
        setSelectedHorseIds(function (prev) {
            return prev.includes(horseId)
                ? prev.filter(function (id) { return id !== horseId; })
                : __spreadArray(__spreadArray([], prev, true), [horseId], false);
        });
    }, []);
    var handleQuoteCreation = useCallback(function () {
        var _a;
        var processedRequiredParamsPayload = selectedHorseIds.reduce(function (acc, horseId) {
            acc[horseId] = applicationFormData[horseId].applicationDetails;
            return acc;
        }, {});
        var processedProductId = (_a = applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[selectedHorseIds[0]]) === null || _a === void 0 ? void 0 : _a.productId;
        var processedApplicationId = selectedHorseIds
            .sort(function (a, b) { return Number(a) - Number(b); })
            .join('-');
        onClick({
            requiredParams: processedRequiredParamsPayload,
            optionalParams: {}
        }, processedProductId, processedApplicationId);
    }, [selectedHorseIds, applicationFormData, onClick]);
    var handleClose = function () {
        setModalOpen(false);
    };
    var handleSelection = function (isSelected, horseID) {
        if (isSelected) {
            toggleSelection(horseID);
        }
        else if (!isFiveHorsesSelected) {
            toggleSelection(horseID);
        }
    };
    var handleSearch = function (searchQuery) {
        setSearchQuery(searchQuery);
    };
    var sortingHelper = function (sortFieldProp) {
        if (sortFieldProp === sortField) {
            if (sortOrderAsc)
                return 'asc';
            return 'desc';
        }
        return 'none';
    };
    var handleSorting = function (field) {
        if (sortField === field) {
            if (sortOrderAsc)
                setSortOrderAsc(false);
            else {
                setSortOrderAsc(true);
            }
        }
        else {
            setSortField(field);
            setSortOrderAsc(true);
        }
    };
    var handleFilterPopup = function (field) {
        if (field === 'gender') {
            setShowGenderPopup(function (prev) { return !prev; });
            setShowYardNamesPopup(false);
        }
        else if (field === 'yardName') {
            setShowYardNamesPopup(function (prev) { return !prev; });
            setShowGenderPopup(false);
        }
    };
    var handleFilters = function () {
        var sanitizedQuery = searchQuery.trim().toLowerCase();
        var searchedHorses;
        if (sanitizedQuery !== '') {
            var searchedFields_1 = ['id', 'passportName'];
            searchedHorses = horses.filter(function (horse) {
                return searchedFields_1.some(function (field) {
                    return horse[field].toLowerCase().trim().includes(sanitizedQuery);
                });
            });
        }
        else {
            searchedHorses = horses;
        }
        var filteredHorses = searchedHorses.filter(function (horse) {
            return allowedGenders.includes(horse.gender) &&
                allowedYardNames.includes(horse.yardName);
        });
        var sortedHorses = filteredHorses.slice().sort(function (horseA, horseB) {
            var valA = horseA[sortField];
            var valB = horseB[sortField];
            if (sortField === 'DOB' || sortField === 'dateAdded') {
                return sortOrderAsc
                    ? new Date(valA).getTime() - new Date(valB).getTime()
                    : new Date(valB).getTime() - new Date(valA).getTime();
            }
            else {
                return sortOrderAsc
                    ? valA.localeCompare(valB, undefined, { numeric: true })
                    : valB.localeCompare(valA, undefined, { numeric: true });
            }
        });
        return sortedHorses;
    };
    var processInsuranceStatus = function (value) {
        if (!value || value.length === 0) {
            return React.createElement("span", null, "--");
        }
        return (React.createElement("div", { className: "flex flex-col gap-1" }, value.map(function (id) { return (React.createElement("div", { key: id, className: "flex items-center justify-start gap-2" },
            React.createElement("span", { className: "h-2 w-2 rounded-full bg-[#42D58E]" }),
            React.createElement("span", null, id))); })));
    };
    var renderHorseRow = function (horse) {
        var isSelected = selectedHorseIds.includes(horse.id);
        var commonClass = 'flex items-center text-left break-all';
        return (React.createElement("div", { key: horse.id, className: "grid grid-cols-[0.5fr_1fr_1fr_1fr_1fr_1fr_1fr] gap-4 mb-2 p-4 rounded-lg border border-solid transition-colors\n        ".concat(isSelected ? 'border-primary' : 'border-gray-200', "\n        ").concat(!isSelected && isFiveHorsesSelected
                ? 'border-gray-200 bg-gray-100 text-gray-400 pointer-events-none'
                : 'cursor-pointer hover:bg-gray-50', "\n        "), onClick: function () { return handleSelection(isSelected, horse.id); } },
            React.createElement("div", { className: "".concat(commonClass, " font-medium") }, horse.id),
            React.createElement("div", { className: commonClass }, horse.passportName),
            React.createElement("div", { className: commonClass }, horse.gender),
            React.createElement("div", { className: commonClass }, horse.DOB),
            React.createElement("div", { className: commonClass }, horse.dateAdded),
            React.createElement("div", { className: commonClass }, horse.yardName),
            React.createElement("div", { className: "".concat(commonClass, " justify-between gap-1") },
                React.createElement("span", { className: "flex-grow" }, processInsuranceStatus(horse.insuranceStatus)),
                React.createElement(Checkbox2, { checked: isSelected, disabled: !isSelected && isFiveHorsesSelected }))));
    };
    return (React.createElement("div", { className: "flex flex-col min-h-full items-center w-full absolute top-0 -ml-4" },
        React.createElement("div", { className: "sticky top-0 w-full bg-white z-10" },
            React.createElement(PolicyStepsHeader, { pageName: "Select Horse(s)", backButtonText: "Close", handleClose: handleClose, handleNext: handleQuoteCreation, nextButtonText: "Start Quote with ".concat(isFiveHorsesSelected ? 'Max' : selectedHorseIds.length, " horse(s)"), isNextDisabled: selectedHorseIds.length === 0 })),
        React.createElement("div", { className: "w-full px-5 py-6 flex flex-col flex-grow" },
            React.createElement("div", { className: "w-full flex items-center bg-white border border-solid border-gray-200 rounded-xl px-4 py-3" },
                React.createElement(FontAwesomeIcon, { icon: faMagnifyingGlass, color: "#919CC2", size: "lg", className: "mr-3" }),
                React.createElement("input", { type: "text", placeholder: "Search", className: "w-full outline-none text-gray-600 placeholder-[#707EAE] bg-transparent", value: searchQuery, onChange: function (e) { return handleSearch(e.target.value); } })),
            React.createElement("div", { className: "w-full mx-auto border border-solid border-gray-200 rounded-lg mt-6 p-6 bg-white shadow-sm" },
                React.createElement("div", { className: "grid grid-cols-[0.5fr_1fr_1fr_1fr_1fr_1fr_1fr] gap-4 font-bold mb-2 bg-[#F5F7FA] rounded-lg p-4 text-[#3B4265]" },
                    React.createElement(TableHeaderCell, { title: "ID", filterType: "sort", onClick: function () { return handleSorting('id'); }, sortOrder: sortingHelper('id') }),
                    React.createElement(TableHeaderCell, { title: "Name", filterType: "sort", onClick: function () { return handleSorting('passportName'); }, sortOrder: sortingHelper('passportName') }),
                    React.createElement("div", { className: "relative flex" },
                        React.createElement(TableHeaderCell, { title: "Gender", filterType: "filter", onClick: function () { return handleFilterPopup('gender'); } }),
                        showGenderPopup && (React.createElement(FilterPopup, { options: extractUniqueValues('gender'), selectedOptions: allowedGenders, onSelectionChange: setAllowedGenders, onClose: function () { return setShowGenderPopup(false); } }))),
                    React.createElement(TableHeaderCell, { title: "DOB", filterType: "sort", onClick: function () { return handleSorting('DOB'); }, sortOrder: sortingHelper('DOB') }),
                    React.createElement(TableHeaderCell, { title: "Date Added", filterType: "sort", onClick: function () { return handleSorting('dateAdded'); }, sortOrder: sortingHelper('dateAdded') }),
                    React.createElement("div", { className: "relative flex" },
                        React.createElement(TableHeaderCell, { title: "Yard", filterType: "filter", onClick: function () { return handleFilterPopup('yardName'); } }),
                        showYardNamesPopup && (React.createElement(FilterPopup, { options: extractUniqueValues('yardName'), selectedOptions: allowedYardNames, onSelectionChange: setAllowedYardNames, onClose: function () { return setShowYardNamesPopup(false); } }))),
                    React.createElement("div", { className: "text-left" }, "Insurance Status")),
                handleFilters().length > 0 ? (handleFilters().map(renderHorseRow)) : (React.createElement("div", { className: "text-center py-8 text-gray-500" }, "No horses match your current filters"))))));
};
export default HorseGroupSelection;
